var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-sidebar--contact-us"},[_c('h2',[_vm._v(_vm._s(_vm.$t(`${_vm.base}.title`)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t(`${_vm.base}.description`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }